import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Grid } from "@mui/material";
import { motion } from "framer-motion";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { ImageInfo } from "../ImageList";
import { CharityDonation } from "./CharityDonation";
import { CartButton, ImageTile, ImageTitle, NotAvailable, Spec, SpecTitle, Specs, slider } from './ImageComponents';

const ImageOriginal = ({
  id,
  title,
  original,
  longText,
}: ImageInfo) => {

  return (
    <motion.div
      key={id}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <Grid
        container
        rowSpacing={2}
        columnSpacing={5}
        columns={{ xs: 1, md: 2, lg: 2, xl: 2 }}
      >
        <Grid item xs={1}>
          <ImageTile>
            <Slide {...slider}>
              <div className="each-slide-effect">
                <img
                  src={`/images/originals/${id}/700_1.jpeg`}
                  width={"100%"}
                  alt={title}
                />
              </div>
              <div className="each-slide-effect">
                <img
                  src={`/images/originals/${id}/700_2.jpeg`}
                  width={"100%"}
                  alt={title}
                />
              </div>
              <div className="each-slide-effect">
                <img
                  src={`/images/originals/${id}/700_3.jpeg`}
                  width={"100%"}
                  alt={title}
                />
              </div>
            </Slide>
          </ImageTile>
        </Grid>
        <Grid item xs={1}>
          <ImageTitle>{title}</ImageTitle>
          {longText}

          <SpecTitle>Specifications:</SpecTitle>
          <Specs>
            <Spec>
              <b>Medium:</b> {original.medium}
            </Spec>
            <Spec>
              <b>Dimentions:</b> {original.dimentions}
            </Spec>
          </Specs>

          {original.etsyUrl ? (
            <>
              <CartButton variant="contained" size="small" href={original.etsyUrl} startIcon={<AddShoppingCartIcon />}>Buy on Etsy</CartButton>
              <CharityDonation />
            </>
          ) : (
            <>
              <br />
              <NotAvailable>Sorry, this original artwork is not available to purchase.</NotAvailable>
            </>
          )
          }
        </Grid>
      </Grid >
    </motion.div>
  );
};

export default ImageOriginal;
